const setterAndGetter = (name) => {
    return  {
        get: () => {
            return JSON.parse(localStorage.getItem(name));
        },
        set: (values) => {
            localStorage.setItem(name, JSON.stringify(values));
        }
    }
}

const localStorageService = {
    cities: setterAndGetter('cities'),
    locations: setterAndGetter('locations'),
    items: setterAndGetter('items'),
    owners: setterAndGetter('owners'),
    locks: setterAndGetter('locks'),
    schedules: setterAndGetter('schedules')
}

export default localStorageService;